import { useLayoutEffect, type RefObject } from "react";

/**
 * Grow a textarea with its content, up to a ceiling.
 *
 * Driven by the value rather than by onChange: a composer is also emptied
 * programmatically after sending, and a handler that only fires on keystrokes
 * leaves the box at the height of the message that was just sent until the
 * next one is typed.
 */
export function autoGrow(el: HTMLTextAreaElement | null | undefined, maxHeight: number): void {
  if (!el) return;
  el.style.height = "auto";
  el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
  el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
}

export function useAutoGrow(
  ref: RefObject<HTMLTextAreaElement>,
  value: string,
  maxHeight: number,
): void {
  useLayoutEffect(() => {
    autoGrow(ref.current, maxHeight);
  }, [ref, value, maxHeight]);
}
